<ion-input class="room-input"
  [(ngModel)]="roomName"
  name="roomName"
  [maxlength]="maxlength"
  placeholder="Room Name"
  autocomplete="on"
  required
></ion-input>
